import { mergeClassName } from '../../utils/mergeClassName'

type ReactDiv = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const Label: React.FC<ReactDiv> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={mergeClassName(
        'font-body2 text-black text-sm',
        className,
      )}
      {...props}
    >
      { children }
    </div>
  )
}

export default Label
